import * as React from 'react';
import { NavLink, Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Container, Menu } from 'semantic-ui-react';

import { Contexto } from 'src/contexto';
import Administrar from './Administrar';
import Salas from './componentes/Salas';
import DetalleDelCurso from './DetalleDelCurso';
import Horario from './Horario';
import TomaDeHorarios from './TomaDeHorarios';

type Props = RouteComponentProps<{}>;

class Horarios extends React.Component<Props> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public render() {
        const rutaBase = this.props.match.url;

        const esAdministradorDeCursos = this.context.usuarioActual.tieneAlgunaDeEstasFunciones(
            'administrador_cursos',
        );
        const esInscriptor = this.context.usuarioActual.tieneAlgunaDeEstasFunciones(
            'inscriptor_cursos',
        );

        return (
            <Container>
                <Menu pointing secondary>
                    {esAdministradorDeCursos && (
                        <Menu.Item
                            as={NavLink}
                            to={rutaBase + '/administrar'}
                            content='Administrar cursos'
                        />
                    )}
                    {esInscriptor && (
                        <Menu.Item
                            as={NavLink}
                            to={rutaBase + '/inscribir'}
                            content='Toma de horarios'
                        />
                    )}
                    <Menu.Item as={NavLink} to={rutaBase + '/horario'} content='Horario' />
                </Menu>

                <Route
                    path={[rutaBase + '/administrar', rutaBase + '/horario']}
                    render={({ match }) => (
                        <Menu tabular>
                            <Menu.Item
                                as={NavLink}
                                exact
                                to={match.url + '/cursos'}
                                content='Cursos'
                            />
                            <Menu.Item
                                as={NavLink}
                                exact
                                to={match.url + '/salas'}
                                content='Salas'
                            />
                        </Menu>
                    )}
                />

                {esAdministradorDeCursos && (
                    <Route
                        path={rutaBase + '/administrar/cursos'}
                        children={({ match }) => <Administrar oculto={!match} />}
                    />
                )}
                <Route
                    path={rutaBase + '/horario/cursos'}
                    children={({ match }) => <Horario oculto={!match} />}
                />

                <Switch>
                    {esAdministradorDeCursos ? (
                        <Redirect exact from={rutaBase} to={rutaBase + '/administrar/cursos'} />
                    ) : esInscriptor ? (
                        <Redirect exact from={rutaBase} to={rutaBase + '/inscribir'} />
                    ) : (
                        <Redirect exact from={rutaBase} to={rutaBase + '/horario/cursos'} />
                    )}
                    <Redirect
                        exact
                        from={rutaBase + '/administrar'}
                        to={rutaBase + '/administrar/cursos'}
                    />
                    <Redirect
                        exact
                        from={rutaBase + '/horario'}
                        to={rutaBase + '/horario/cursos'}
                    />

                    <Route
                        exact
                        path={[rutaBase + '/administrar/salas', rutaBase + '/horario/salas']}
                        component={Salas}
                    />

                    {esInscriptor && (
                        <Route path={rutaBase + '/inscribir'} component={TomaDeHorarios} />
                    )}

                    <Route path={rutaBase + '/cursos/:id'} component={DetalleDelCurso} />
                </Switch>
            </Container>
        );
    }
}

export default Horarios;



// WEBPACK FOOTER //
// ./src/modulos/Horarios/index.tsx